/**
 * L2-R7: moved to @miq/shared-models (lib/columns/lov-datakey-factory.ts). This shim keeps the old
 * import path working; new code should import from '@miq/shared-models'.
 *
 * It had to move because it was the last host-only dependency of `DataCellFormatterPipe`, which is
 * now @miq/platform-ui code.
 */
export { getLovValueKey } from '@miq/shared-models';
